import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class ServiceModel extends BaseModel {
    RouteName = "ServicesTypes";
    protected AuthState: boolean = true;

    public async GetAll() {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async GetSearch(name:any,description:any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/search?name=${name}&description=${description}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async GetById(id:number|string) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/${id}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async SubmitData(data: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }
    public async EditData(data: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).put(`${this.RouteName}`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }
    public async Delete(data: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).delete(`${this.RouteName}`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }

}
